module.exports = __webpack_public_path__ + "assets/img/perinatal-m.2e7d0e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/perinatal-m.jpg
// module id = v4Yc
// module chunks = 0